(() => {
  const root = document.documentElement;
  const toggle = document.querySelector("[data-tpb-menu-toggle]");
  const nav = document.querySelector("[data-tpb-mobile-nav]");

  const setMenu = (open) => {
    root.classList.toggle("tpb-menu-open", open);
    toggle?.setAttribute("aria-expanded", String(open));
    nav?.setAttribute("aria-hidden", String(!open));
  };

  toggle?.addEventListener("click", () => {
    setMenu(!root.classList.contains("tpb-menu-open"));
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") setMenu(false);
  });

  const carousel = document.querySelector("[data-tpb-carousel]");
  if (!carousel) return;
  const slides = [...carousel.querySelectorAll("[data-tpb-slide]")];
  const dots = [...carousel.querySelectorAll("[data-tpb-dot]")];
  if (slides.length < 2) return;

  let active = 0;
  let timer;
  const show = (index) => {
    active = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const selected = slideIndex === active;
      slide.classList.toggle("is-active", selected);
      slide.toggleAttribute("inert", !selected);
      slide.setAttribute("aria-hidden", String(!selected));
      const videos = [...slide.querySelectorAll("video")];
      videos.forEach((video) => {
        const visible = window.getComputedStyle(video).display !== "none";
        if (selected && visible) video.play().catch(() => {});
        else video.pause();
      });
    });
    dots.forEach((dot, dotIndex) => {
      const selected = dotIndex === active;
      dot.classList.toggle("is-active", selected);
      dot.setAttribute("aria-current", selected ? "true" : "false");
    });
  };
  const start = () => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    window.clearInterval(timer);
    timer = window.setInterval(() => show(active + 1), 6500);
  };
  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      show(index);
      start();
    });
  });
  carousel.addEventListener("mouseenter", () => window.clearInterval(timer));
  carousel.addEventListener("mouseleave", start);
  show(0);
  start();
})();

(() => {
  const carousels = [...document.querySelectorAll("[data-tpb-product-carousel]")];

  carousels.forEach((carousel) => {
    if (carousel.dataset.tpbInitialized === "true") return;
    carousel.dataset.tpbInitialized = "true";

    const track = carousel.querySelector("[data-tpb-product-track]");
    const previous = carousel.querySelector("[data-tpb-product-prev]");
    const next = carousel.querySelector("[data-tpb-product-next]");
    if (!track) return;

    const scrollPage = (direction) => {
      const card = track.querySelector(".tpb-product-card");
      if (!card) return;
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      const visibleCards = Math.max(
        1,
        Math.floor((track.clientWidth + gap) / (card.getBoundingClientRect().width + gap)),
      );
      track.scrollBy({
        left: direction * (card.getBoundingClientRect().width + gap) * visibleCards,
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
      });
    };

    const updateControls = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      previous?.toggleAttribute("disabled", track.scrollLeft <= 1);
      next?.toggleAttribute("disabled", track.scrollLeft >= maxScroll - 1);
    };

    previous?.addEventListener("click", () => scrollPage(-1));
    next?.addEventListener("click", () => scrollPage(1));
    track.addEventListener("scroll", updateControls, { passive: true });
    updateControls();

    carousel.querySelectorAll("[data-tpb-card-media]").forEach((media) => {
      if (media.dataset.tpbInitialized === "true") return;
      media.dataset.tpbInitialized = "true";

      const frames = [...media.querySelectorAll("[data-tpb-card-frame]")];
      if (frames.length < 2) return;

      const select = (nextIndex) => {
        const normalized = (nextIndex + frames.length) % frames.length;
        media.dataset.mediaIndex = String(normalized);
        media.classList.add("is-user-selected");
      };

      media.querySelector("[data-tpb-card-prev]")?.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        select(Number(media.dataset.mediaIndex || 0) - 1);
      });

      media.querySelector("[data-tpb-card-next]")?.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        select(Number(media.dataset.mediaIndex || 0) + 1);
      });
    });
  });
})();
